import blendOnto from './blendOnto'

const createFlatLayImage = ({
	canvas,
	//	createCanvas returns a new canvas at the given size - here's the browser version - the server version is passed in.
	createCanvas = (width, height) => {
		const can = global.document.createElement('canvas')
		can.width = width
		can.height = height
		return can
	},
	canvasWidth = 1080,
	canvasHeight = 1080,
	fixCanvasDPI = () => { },
	template,
	callback,
	imageInstances
}) => {
	const completeCallback = callback
	const theTemplate = template.slice()

	const drawFlatlay = ({ images, url, defaultOptions, doneCallback }) => {
		const ctx = canvas.getContext('2d')
		ctx.fillStyle = '#ffffff'
		ctx.fillRect(0, 0, canvas.width, canvas.height)

		const calculateDimensions = (o, image, theCanvas) => {
			const w = theCanvas.width * (o.s / 100)
			const h = (image.height / image.width) * w
			const x = theCanvas.width * (o.x / 100)
			const y = theCanvas.height * (o.y / 100)
			return { w, h, x, y }
		}

		const drawTemplate = (tmpl, imgs) => {
			const off = createCanvas(canvasWidth, canvasHeight).getContext('2d')
			const con = createCanvas(canvasWidth, canvasHeight).getContext('2d')
			off.drawImage(canvas, 0, 0)
			con.drawImage(canvas, 0, 0)

			const ow = canvasWidth
			const oh = canvasHeight

			//	Create order to apply for z-index settings
			const applyOrder = []
			const defaultZIndex = 0
			tmpl.forEach((obj, index) => {
				const options = Object.assign({}, (images[index] && images[index].options) ? images[index].options : defaultOptions || {})

				const o = Object.assign({}, obj, options)
				const image = imgs[index]
				if (image) {
					const dims = calculateDimensions(o, image, canvas)
					const result = { options, o, image, dims, z: typeof o.z !== 'undefined' ? o.z : defaultZIndex }
					applyOrder.push(result)
				}
			})

			//	Apply  our sorted items
			applyOrder.sort((a, b) => a.z - b.z)
			applyOrder.forEach((item) => {
				const o = item.o
				const image = item.image
				const dims = item.dims
				ctx.save()
				off.save()
				con.clearRect(0, 0, ow, oh)
				off.clearRect(0, 0, ow, oh)
				off.translate(dims.x, dims.y)

				if (typeof o.r !== 'undefined') {
					off.rotate(o.r * Math.PI / 180)
				}

				if (typeof o.a !== 'undefined') {
					//	Ref: https://stackoverflow.com/a/10740933/6637365
					off.globalAlpha = o.a
				}

				if (typeof o.h !== 'undefined') {
					off.scale(-1, 1)
				}

				if (typeof o.v !== 'undefined') {
					off.scale(1, -1)
				}

				//	Either use absolute or centered positioning
				if (o.p && o.p === 'ABSOLUTE') {
					off.drawImage(image, 0, 0, dims.w, dims.h)
				} else {
					off.drawImage(image, -dims.w / 2, -dims.h / 2, dims.w, dims.h)
				}

				blendOnto(off, ctx, 'normal')

				off.restore()
				ctx.restore()
			})

			//	Add the url if supplied
			if (url) {
				ctx.font = '22px Arial'
				ctx.fontWeight = 'lighter'
				ctx.fillStyle = '#ddd'
				ctx.textAlign = 'right'
				ctx.fillText(url, canvas.width - 10, canvas.height - 11)
			}

			if (doneCallback) {
				doneCallback(tmpl, imgs)
			}
		}

		drawTemplate(theTemplate, images)
	}

	fixCanvasDPI(canvas)

	//	Draw the flatlay
	drawFlatlay({ images: imageInstances, doneCallback: completeCallback })
}

export default createFlatLayImage



// WEBPACK FOOTER //
// ./src/utilities/Flatlay/createFlatlayImage.js